import DisclaimerPage from './DisclaimerPage';
import {map, route} from 'navi';

export default map(() =>
    route({
        view: DisclaimerPage,
    }),
);
